export function welcomeBack(user: {email?: string; address?: `0x${string}`}) {
	// if (user.email) {
	// 	return `Welcome Back ${user.email}`;
	// } else if (user.address) {
	// 	return `Welcome Back ${user.address}`;
	// }
	return `Welcome Back`;
}
